/* =====================================================================
   Biçimlendirme + elle yazılabilen tarih alanı yardımcıları.
   "kesinlesme.html" içindeki biçimlendirme bölümünden taşındı.
   ===================================================================== */

import { parseIso } from './isGunuHesap';

export const GUN_ADLARI = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
export const AY_ADLARI = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

export function gunAdi(iso) {
  const d = parseIso(iso);
  return d ? GUN_ADLARI[d.getDay()] : '';
}

export function uzunTarih(iso) {
  const d = parseIso(iso);
  if (!d) return '—';
  return `${d.getDate()} ${AY_ADLARI[d.getMonth()]} ${d.getFullYear()}`;
}

export function kisaTarih(iso) {
  const d = parseIso(iso);
  if (!d) return '—';
  return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`;
}

/** 'YYYY-MM-DD' → '18/08/2024' (eğik çizgili kısa biçim). */
export function egikTarih(iso) {
  const d = parseIso(iso);
  if (!d) return '—';
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
}

/** 'GG/AA/YYYY' → 'YYYY-MM-DD'; geçersiz/eksikse '' (var olmayan tarihleri eler). */
export function ddmmToIso(s) {
  if (!s || s.length !== 10) return '';
  const [d, m, y] = s.split('/');
  if (!d || !m || !y) return '';
  const iso = `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
  return parseIso(iso) ? iso : '';
}

/** 'YYYY-MM-DD' → 'GG/AA/YYYY'; geçersizse ''. */
export function isoToDdmm(iso) {
  const v = egikTarih(iso);
  return v === '—' ? '' : v;
}
